import { Loader as Action} from '../../../constants/actionTypes';

const initialState = {
  loaderStatus:false,  
 };

function loaderReducer(state = initialState, actions) {
  switch (actions.type) {
    case Action.SHOW_LOADER:
      return Object.assign({}, state, { loaderStatus: true });
    case Action.HIDE_LOADER:
      return Object.assign({}, state, { loaderStatus: false });
    default:
      return state;
  }
  
}
export default loaderReducer;